import { ThemeOptions } from '@mui/material/styles/createTheme';
import { palette } from '@/theme/palette';

export const MuiStepConnectorStyle = {
  styleOverrides: {
    root: ({ theme }: { theme: ThemeOptions }) => ({
      padding: '8px 8px',
      '.MuiStepConnector-line': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        borderColor: theme?.palette?.neutralGray3?.main ?? palette?.neutralGray3?.main,
        borderWidth: '2px',
      },
      '&.MuiStepConnector-vertical .MuiStepConnector-line': {
        height: '100%',
        minHeight: '32px',
      },
      '&.MuiStepConnector-horizontal .MuiStepConnector-line': {
        width: '100%',
      },
      '&.Mui-completed .MuiStepConnector-line': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        borderColor: theme?.palette?.blue?.dark ?? palette?.blue?.dark,
      },
      '&.Mui-active .MuiStepConnector-line': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        borderColor: theme?.palette?.blue?.dark ?? palette?.blue?.dark,
      },
    }),
  },
};
